import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import SportsSoccerRoundedIcon from "@mui/icons-material/SportsSoccerRounded";
import AssistantPhotoRoundedIcon from "@mui/icons-material/AssistantPhotoRounded";
import StyleRoundedIcon from "@mui/icons-material/StyleRounded";
import AppLayout from "../../../components/ui/AppLayout";
import PageHeader from "../../../components/ui/PageHeader";
import SectionCard from "../../../components/ui/SectionCard";
import LoadingState from "../../../components/ui/LoadingState";
import EmptyState from "../../../components/ui/EmptyState";
import PlayerAvatar from "../../../components/ui/PlayerAvatar";
import api from "../../../api";
import tokens from "../../../theme/tokens";

const podium = [tokens.color.gold, "#9CA3AF", "#B7791F"];

// Artilharia, assistências e cartões. `admin` muda apenas a navegação.
const ClassificacaoArtilhariaPage = ({ admin = true }) => {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/classificacao/jogadores")
      .then((response) => setRanking(response.data.ranking))
      .catch((error) => console.error("Erro ao buscar classificação:", error))
      .finally(() => setLoading(false));
  }, []);

  const top3 = ranking.slice(0, 3);

  return (
    <AppLayout>
      <PageHeader backTo={admin ? "/torneio" : "/squad"} eyebrow="Torneio" title="Artilharia e fair play" subtitle="Ordenado por gols, assistências e menos cartões." />
      {loading ? (
        <LoadingState />
      ) : ranking.length === 0 ? (
        <Card><EmptyState icon={<SportsSoccerRoundedIcon />} title="Nenhum gol registrado ainda" /></Card>
      ) : (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            {top3.map((player, index) => (
              <Grid item xs={12} sm={4} key={player.jogador}>
                <Card sx={{ p: 3, textAlign: "center", borderTop: `4px solid ${podium[index]}` }}>
                  <Box sx={{ position: "relative", display: "inline-block" }}>
                    <PlayerAvatar src={player.foto} name={player.jogador} size={88} />
                    <Box sx={{ position: "absolute", right: -4, bottom: -4, width: 30, height: 30, borderRadius: "50%", bgcolor: podium[index], color: "#fff", display: "grid", placeItems: "center", fontWeight: 700, border: "3px solid #fff" }}>
                      {index + 1}
                    </Box>
                  </Box>
                  <Typography variant="h6" sx={{ mt: 1.5 }} noWrap>{player.jogador}</Typography>
                  <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: "2.4rem", lineHeight: 1, color: tokens.color.brand }}>{player.gols}</Typography>
                  <Typography variant="caption" color="text.secondary">gols · {player.assistencias} assistências</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
          <SectionCard contentSx={{ p: 0, "&:last-child": { pb: 0 } }}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Jogador</TableCell>
                    <TableCell align="center"><Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center"><SportsSoccerRoundedIcon sx={{ fontSize: 16 }} /><span>Gols</span></Stack></TableCell>
                    <TableCell align="center"><Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center"><AssistantPhotoRoundedIcon sx={{ fontSize: 16 }} /><span>Assist.</span></Stack></TableCell>
                    <TableCell align="center"><Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center"><StyleRoundedIcon sx={{ fontSize: 16 }} /><span>Cartões</span></Stack></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ranking.map((player, index) => (
                    <TableRow key={player.jogador} hover>
                      <TableCell sx={{ fontWeight: 700 }}>{index + 1}</TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1.25} alignItems="center">
                          <PlayerAvatar src={player.foto} name={player.jogador} size={32} />
                          <Typography variant="body2" fontWeight={600}>{player.jogador}</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700, color: "primary.main" }}>{player.gols}</TableCell>
                      <TableCell align="center">{player.assistencias}</TableCell>
                      <TableCell align="center">{player.cartoes}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </SectionCard>
        </>
      )}
    </AppLayout>
  );
};

export default ClassificacaoArtilhariaPage;
